module.exports = __webpack_public_path__ + "img/Lebanon.b28154a0.svg";